import $ from 'jquery';
import 'magnific-popup';

let isGlobalVideoHandlerInitialized = {};

export function initVideoGalleryPopup(blockName) {
	if (Object.hasOwn(isGlobalVideoHandlerInitialized, blockName) && isGlobalVideoHandlerInitialized[blockName]) return;
	isGlobalVideoHandlerInitialized[blockName] = true;

	document.addEventListener('click', (e) => {
		const iconVideo = e.target.closest(`.${blockName}__video-icon`);
		if (!iconVideo) return;

		const videoCollection = iconVideo.dataset.videoCollection;

		let videos = [];
		try {
			videos = JSON.parse(videoCollection);
		} catch (error) {
			console.error('Ошибка парсинга данных видео:', error);
			return;
		}

		console.log(videos);

		if (!videos.length) return;

		const items = videos.map(video => ({
			src: `<div class="${blockName}__video-wrap">
				<video controls>
					<source src="${video}" type="video/mp4">
				</video>
			</div>`,
			type: 'inline'
		}));

		$.magnificPopup.open({
			items: items,
			gallery: {
				enabled: true,
				navigateByImgClick: false,
				preload: [0, 1]
			},
			type: 'inline',
			mainClass: `${blockName}__video-popup`,
			callbacks: {
				open: function () {
					const videoEl = this.content.find('video')[0];
					if (videoEl) {
						this.currItem._videoEl = videoEl;
						playVideo(videoEl);
					}
				},
				close: function () {
					const allVideos = this.content.find('video');
					allVideos.each(function () {
						stopVideo(this);
					});
				},
				afterChange: function () {
					if (this.currItem._videoEl) {
						stopVideo(this.currItem._videoEl);
						delete this.currItem._videoEl;
					}

					const videoEl = this.content.find('video')[0];
					if (videoEl) {
						this.currItem._videoEl = videoEl;
						playVideo(videoEl);
					}
				}
			}
		});
	});
}

function playVideo(videoEl) {
	// Запускаем воспроизведение
	const playPromise = videoEl.play();
	if (playPromise !== undefined) {
		playPromise.catch(error => {
			console.warn("Воспроизведение видео было прервано браузером:", error.message);
		});
	}

	// Обработчик закрытия попапа при выходе из полноэкранного режима
	const closePopupIfNotFullscreen = () => {
		const isFullscreen = !!(
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			videoEl.webkitDisplayingFullscreen
		);
		if (!isFullscreen) {
			setTimeout(() => {
				if ($.magnificPopup.instance) {
					$.magnificPopup.close();
				}
			}, 200);
		}
	};

	// Добавляем слушатели для полноэкранного режима
	document.addEventListener('fullscreenchange', closePopupIfNotFullscreen);
	document.addEventListener('webkitfullscreenchange', closePopupIfNotFullscreen);
	videoEl.addEventListener('webkitendfullscreen', closePopupIfNotFullscreen);

	// Сохраняем обработчик для последующего удаления
	videoEl._fullscreenHandler = closePopupIfNotFullscreen;
}

function stopVideo(videoEl) {
	// Проверяем, что элемент существует
	if (!videoEl) return;

	// Останавливаем видео
	videoEl.pause();
	videoEl.currentTime = 0;

	// Удаляем слушатели полноэкранного режима
	if (videoEl._fullscreenHandler) {
		document.removeEventListener('fullscreenchange', videoEl._fullscreenHandler);
		document.removeEventListener('webkitfullscreenchange', videoEl._fullscreenHandler);
		videoEl.removeEventListener('webkitendfullscreen', videoEl._fullscreenHandler);
		delete videoEl._fullscreenHandler;
	}

	// Очищаем источник видео для полной остановки загрузки (опционально)
	// videoEl.removeAttribute('src');
	// videoEl.load();
}